import Grid from '@mui/material/Grid2';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { IoMdClose } from 'react-icons/io';
import Input from 'components/Common/Input';
import { MdOutlineEdit, MdOutlineDone } from 'react-icons/md';
import { Box, Button, IconButton, Typography, Link as MUILink } from '@mui/material';
import { useConfigureIntegration } from 'apis/agency/integrations/hook';
import ReactMarkdown from 'react-markdown';
import IntegrationLoader from './Loader';
import { EmptyStateView } from '@/components/Common/EmptyStateView';

export default function MyIntegrations({ integrations, isLoading }: { integrations: any; isLoading?: boolean }) {
  const [editResellAmount, setEditResellAmount] = useState<string | null>(null);
  const { mutateAsync: configureIntegration, isPending } = useConfigureIntegration();

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      reseller_price: ''
    }
  });

  const onSubmit = (data: any, itemId: string) => {
    const payload = { id: itemId, ...data };
    configureIntegration(payload);
    setEditResellAmount(null);
    reset();
  };

  if (isLoading) {
    return <IntegrationLoader />;
  }

  return (
    <Grid container spacing={2} mt={1}>
      {integrations?.data?.length ? (
        integrations?.data?.map((item: any, index: number) => (
          <Grid
            key={index}
            size={{ xs: 12, md: 6, lg: 4 }}
            bgcolor='white'
            p={2}
            border='1px solid #ECECEC'
            borderRadius={2}
            display='flex'
            flexDirection='column'
            justifyContent='space-between'
          >
            <Box>
              <Box display='flex' justifyContent='space-between' alignItems='center'>
                <img src={item.avatar_url} alt={item.name} style={{ maxHeight: 30, maxWidth: '150px' }} />
                <Typography
                  sx={{
                    color: '#077f13',
                    bgcolor: '#dbfcde',
                    px: 2,
                    fontSize: 14,
                    borderRadius: '15px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 0.3
                  }}
                >
                  {item.wholesale_price === '0.0' ? (
                    <b>Free</b>
                  ) : (
                    <>
                      <b>${item.wholesale_price}</b>
                      <Box component='span' fontSize={10}>
                        /Connection/Month
                      </Box>
                    </>
                  )}
                </Typography>
              </Box>

              <Typography my={1} color='secondary' fontSize={14}>
                <ReactMarkdown
                  components={{
                    a: ({ ...props }) => (
                      <MUILink
                        {...(props as any)}
                        component='a'
                        target='_blank'
                        rel='noopener'
                        sx={{ color: 'primary.main', fontWeight: 500 }}
                      />
                    ),
                    p: ({ ...props }) => <span {...props} />
                  }}
                >
                  {item?.description}
                </ReactMarkdown>
              </Typography>
            </Box>

            <Box display='flex' justifyContent='space-between' alignItems='flex-end' mt={2}>
              <Box width='8rem'>
                <Box display='flex' justifyContent='space-between' alignItems='center'>
                  <Typography fontSize={12} color='secondary'>
                    Reseller Price
                  </Typography>
                  {editResellAmount !== String(item.id) && (
                    <IconButton
                      onClick={() => {
                        setEditResellAmount(String(item.id));
                        reset({ reseller_price: item.reseller_price });
                      }}
                      sx={{ bgcolor: '#ECECEC' }}
                    >
                      <MdOutlineEdit style={{ fontSize: 14 }} />
                    </IconButton>
                  )}
                </Box>

                <Box
                  component='form'
                  onSubmit={handleSubmit((data) => onSubmit(data, String(item.id)))}
                  color='#077f13'
                >
                  {editResellAmount === String(item.id) ? (
                    <Box display='flex' alignItems='center' gap={1}>
                      <Input name='reseller_price' control={control} size='small' />
                      <IconButton size='small' type='submit' disabled={isPending} sx={{ bgcolor: '#ECECEC' }}>
                        <MdOutlineDone fontSize='small' />
                      </IconButton>
                      <IconButton size='small' onClick={() => setEditResellAmount(null)} sx={{ bgcolor: '#ECECEC' }}>
                        <IoMdClose fontSize='small' />
                      </IconButton>
                    </Box>
                  ) : (
                    <Typography fontWeight='500' fontSize={18}>
                      ${item.reseller_price}
                    </Typography>
                  )}
                  <Typography fontWeight='500' color='#077f13' fontSize={12}>
                    /Connection/Month
                  </Typography>
                </Box>
              </Box>

              <Link to={String(item.id)}>
                <Button>Read & Configure</Button>
              </Link>
            </Box>
          </Grid>
        ))
      ) : (
        <Box mx='auto'>
          <EmptyStateView />
        </Box>
      )}
    </Grid>
  );
}
